import { render, staticRenderFns } from "./CardSmallLocation.vue?vue&type=template&id=09649865&scoped=true"
import script from "./CardSmallLocation.vue?vue&type=script&lang=js"
export * from "./CardSmallLocation.vue?vue&type=script&lang=js"
import style0 from "./CardSmallLocation.vue?vue&type=style&index=0&id=09649865&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09649865",
  null
  
)

export default component.exports